import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import "./Chart.css";
import { useEffect, useState } from "react";
import baseConfig from "../../ChartConfigFiles/BaseChartConfig";
import seriesLabel from "highcharts/modules/series-label";
import ChartDataCheck from "./ChartDataCheck";
import tagLong from "../../ChartConfigFiles/Tag_long.png";

seriesLabel(Highcharts);
Highcharts.seriesTypes.line.prototype.drawLegendSymbol =
  Highcharts.seriesTypes.area.prototype.drawLegendSymbol;

Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

const LineChart = (props) => {
  const [chartOptions, setChartOptions] = useState({
    ...baseConfig,
    chart: {
      ...baseConfig.chart,
      type: "line",
    },
    title: {
      ...baseConfig.title,
      margin: 16,
    },
    plotOptions: {
      ...baseConfig.plotOptions,
      series: {
        ...baseConfig.plotOptions.series,
        label: {
          enabled: true,
        },
      },
    },
  });

  const yAxisLabelFormat =
    props.dataTreatment === "absolute" ? "{value:,f}" : "{value}%";

  useEffect(() => {
    setChartOptions((prevOptions) => ({
      ...prevOptions,
      series: props.chartData,
      xAxis: {
        ...prevOptions.xAxis,
        title: {
          text: "",
        },
        type: props.dateType,
      },
      yAxis: {
        ...prevOptions.yAxis,
        labels: { ...prevOptions.yAxis.labels, format: yAxisLabelFormat },
      },
      plotOptions: {
        ...prevOptions.plotOptions,
        series: {
          ...prevOptions.plotOptions.series,
          label: {
            enabled: props.comparison === "on" ? true : false,
          },
        },
      },
    }));
  }, [props.chartData]);

  return (
    <div className="chart-container">
      <div className="main-data-explorer-chart-display" ref={props.chartRef}>
        <img
          alt=""
          className="chart-tag-long"
          id="tag-long"
          src={tagLong}
          style={{ visibility: "visible" }}
        />
        <div className="chart-header">
          <div className="chart-title">{props.chartTitle}</div>
          <div className="chart-subtitle">{props.chartSubtitle}</div>
        </div>
        <div className="chart-body">
          <ChartDataCheck
            isLoading={props.isLoading}
            chartData={props.chartData}
          >
            <div className="chart line-chart">
              <HighchartsReact
                highcharts={Highcharts}
                containerProps={{
                  style: {
                    height: "100%",
                    width: "100%",
                    borderRadius: "15px",
                  },
                }}
                options={chartOptions}
              />
            </div>
          </ChartDataCheck>
        </div>
        <div className="chart-footer">
          <div className="source-text">
            Source: Ember Electricity Data Explorer, ember-energy.org
          </div>
          <div className="logo-container">
            <img
              alt=""
              className="logo"
              id="logo"
              src="https://public.flourish.studio/uploads/3bd4add8-1f15-49c6-b134-5ecfe0de6a0a.png"
              style={{ visibility: "visible" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineChart;
